import React from 'react';
import { Testimonial } from './types';
import { CheckCircleIcon } from 'lucide-react';
interface TestimonialCardProps {
  testimonial: Testimonial;
}
export function TestimonialCard({
  testimonial
}: TestimonialCardProps) {
  return <div className="bg-[#f8f9fa] border border-gray-200 rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300 flex flex-col gap-4" data-id="element-1683">
      {/* Header with avatar and name */}
      <div className="flex items-center gap-3" data-id="element-1684">
        <div className="relative" data-id="element-1685">
          <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover" data-id="element-1686" />
          {testimonial.verified && <div className="absolute -bottom-1 -right-1 w-5 h-5 bg-[#3ab795] rounded-full flex items-center justify-center border-2 border-[#f8f9fa]" data-id="element-1687">
              <CheckCircleIcon className="w-3 h-3 text-white" strokeWidth={3} data-id="element-1688" />
            </div>}
        </div>
        <div data-id="element-1689">
          <h4 className="font-semibold text-[#1D1D1D]" data-id="element-1690">{testimonial.name}</h4>
          <p className="text-sm text-gray-600" data-id="element-1691">
            {testimonial.role}
            {testimonial.company && ` • ${testimonial.company}`}
          </p>
        </div>
      </div>

      {/* Testimonial content */}
      <p className="text-gray-600 leading-relaxed" data-id="element-1692">{testimonial.content}</p>
    </div>;
}